import { useRef, useState } from 'react';
import { ImagePlus, Loader2, X } from 'lucide-react';
import { toast } from 'sonner';
import { resizeImage, uploadAttachment, useAttachmentUrl } from '../lib/media';

export function Thumb({ id, onRemove, size = 'h-14 w-14' }) {
  const url = useAttachmentUrl(id);
  return (
    <div data-testid={`attachment-${id}`} className={`relative ${size} shrink-0 rounded-lg overflow-hidden border border-white/15 bg-black/40`}>
      {url ? <img src={url} alt="Riferimento" className="h-full w-full object-cover" /> : <Loader2 className="m-auto mt-4 h-4 w-4 animate-spin text-slate-500" />}
      {onRemove && <button data-testid={`attachment-remove-${id}`} onClick={onRemove} aria-label="Rimuovi immagine" className="absolute top-0.5 right-0.5 rounded-full bg-black/70 p-0.5"><X className="h-3 w-3" /></button>}
    </div>
  );
}

/** Photo/screenshot picker: uploads to storage immediately and returns attachment ids (max 4). */
export function useAttachments() {
  const [ids, setIds] = useState([]);
  const [uploading, setUploading] = useState(0);
  const input = useRef(null);
  const add = async (files) => {
    const list = Array.from(files || []).filter((f) => f.type.startsWith('image/')).slice(0, 4 - ids.length);
    if (!list.length) return;
    setUploading((n) => n + list.length);
    for (const f of list) {
      try { const id = await uploadAttachment(await resizeImage(f)); setIds((x) => [...x, id].slice(0, 4)); }
      catch (e) { toast.error(e.message || 'Caricamento immagine non riuscito'); }
      setUploading((n) => n - 1);
    }
  };
  const picker = (disabled) => (
    <>
      <input ref={input} type="file" accept="image/*" multiple hidden data-testid="architect-attach-input" onChange={(e) => { add(e.target.files); e.target.value = ''; }} />
      <button data-testid="architect-attach-btn" type="button" disabled={disabled || ids.length >= 4} onClick={() => input.current?.click()} aria-label="Allega foto o screenshot" title="Allega foto, schizzi o screenshot (max 4)"
        className="h-9 w-9 shrink-0 rounded-lg bg-white/5 hover:bg-white/10 text-slate-300 flex items-center justify-center disabled:opacity-40">
        {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />}
      </button>
    </>
  );
  return { ids, uploading, add, clear: () => setIds([]), remove: (id) => setIds((x) => x.filter((y) => y !== id)), picker };
}
